import React from 'react'
import { Modal } from 'antd'

const AdminCModal = ({ show, setShow, children, width }: any) => {
	return (
		<Modal
			open={show}
			onOk={() => {
				setShow(false)
			}}
			onCancel={() => {
				setShow(false)
			}}
			closable={false}
			footer={null}
			getContainer={document.getElementById('root') || ''}
			width={width ? width : 500}>
			{children}
		</Modal>
	)
}

export default AdminCModal
